<template>
  <v-row density="compact">
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.term"
        :items="ma_days"
        label="Fast EMA Period"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('term', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.term2"
        :items="ma_days"
        label="Slow EMA Period"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('term2', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.signal"
        :items="ma_days"
        label="Signal EMA Period"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('signal', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-select
        :model-value="rule.config.above_below"
        :items="items"
        label="above or below threshold"
        hint="above or below threshold"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('above_below', $event)"
      />
    </v-col>
    <v-col
      v-if="
        rule.config.above_below == 'trending up last XX days' ||
        rule.config.above_below == 'trending down last XX days'
      "
      cols="12"
      sm="12"
    >
      <v-text-field
        :model-value="rule.config.days"
        density="compact"
        hide-details
        variant="outlined"
        label="Trending # days"
        @update:model-value="updateConfig('days', $event)"
      />
    </v-col>
    <v-col
      v-if="
        rule.config.above_below == 'bullish divergence' ||
        rule.config.above_below == 'bearish divergence'
      "
      cols="12"
      sm="12"
    >
      <v-text-field
        :model-value="rule.config.days"
        density="compact"
        hide-details
        variant="outlined"
        label="Bullish/Bearish Divergence days"
        @update:model-value="updateConfig('days', $event)"
      />
    </v-col>

    <v-col
      v-if="
        rule.config.above_below == 'above' ||
        rule.config.above_below == 'below' ||
        rule.config.above_below == 'crossed above' ||
        rule.config.above_below == 'crossed below'
      "
      cols="12"
      sm="12"
    >
      <v-text-field
        :model-value="rule.config.threshold"
        density="compact"
        hide-details
        variant="outlined"
        label="MACD Threshold"
        @update:model-value="updateConfig('threshold', $event)"
      />
    </v-col>

    <v-col
      v-if="
        (1 == 2 && rule.config.above_below == 'trending up last XX days') ||
        rule.config.above_below == 'trending down last XX days'
      "
      cols="12"
      sm="12"
    >
      <v-text-field
        :model-value="rule.config.threshold"
        density="compact"
        hide-details
        variant="outlined"
        label="MACD Threshold"
        @update:model-value="updateConfig('threshold', $event)"
      />
    </v-col>

    <v-col
      v-if="
        (1 == 2 && rule.config.above_below == 'trending up last XX days') ||
        rule.config.above_below == 'trending down last XX days'
      "
      cols="12"
      sm="12"
    >
      <v-text-field
        :model-value="rule.config.threshold"
        density="compact"
        hide-details
        variant="outlined"
        label="Min MACD"
        @update:model-value="updateConfig('threshold', $event)"
      />
    </v-col>

    <v-col
      v-if="
        (1 == 2 && rule.config.above_below == 'trending up last XX days') ||
        rule.config.above_below == 'trending down last XX days'
      "
      cols="12"
      sm="12"
    >
      <v-text-field
        :model-value="rule.config.threshold_max"
        density="compact"
        hide-details
        variant="outlined"
        label="Max MACD"
        @update:model-value="updateConfig('threshold_max', $event)"
      />
    </v-col>
    <v-col
      v-if="
        (1 == 2 && rule.config.above_below == 'bullish divergence') ||
        rule.config.above_below == 'bearish divergence'
      "
      cols="12"
      sm="12"
    >
      <v-text-field
        :model-value="rule.config.threshold"
        density="compact"
        hide-details
        variant="outlined"
        label="Min MACD"
        @update:model-value="updateConfig('threshold', $event)"
      />
    </v-col>
    <v-col
      v-if="
        (1 == 2 && rule.config.above_below == 'bullish divergence') ||
        rule.config.above_below == 'bearish divergence'
      "
      cols="12"
      sm="12"
    >
      <v-text-field
        :model-value="rule.config.threshold_max"
        density="compact"
        hide-details
        variant="outlined"
        label="Max MACD"
        @update:model-value="updateConfig('threshold_max', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      items: [
        'above',
        'below',
        'crossed above',
        'crossed below',
        'above signal line',
        'below signal line',
        'crossed above signal line',
        'crossed below signal line',
        'trending up last XX days',
        'trending down last XX days',
        'bullish divergence',
        'bearish divergence'
      ],
      editedTa: {
        enabled: true,
        above_below: 'above',
        term: 12,
        term2: 26,
        signal: 9,
        rule_type: 'macd',
        threshold: 0,
        threshold_max: 100,
        days: 5,
        long_short: 'long'
      },
      defaultTa: {
        enabled: true,
        above_below: 'above',
        term: 12,
        term2: 26,
        signal: 9,
        rule_type: 'macd',
        threshold: 0,
        threshold_max: 100,
        days: 5,
        long_short: 'long'
      },
      ma_days: []
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  mounted() {
    this.ma_days = []
    for (var i = 2; i < 71; i++) {
      this.ma_days.push(i)
    }
    for (i = 75; i < 301; i += 5) {
      this.ma_days.push(i)
    }
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'macd') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultTa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
